import { GBP_URL } from './contact';

export const SITE_URL = 'https://www.leadworkz.com';

export const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${SITE_URL}/#organization`,
    name: "Lead Workz",
    url: SITE_URL,
    logo: `${SITE_URL}/images/shared/logo_favi_color.webp`,
    image: `${SITE_URL}/images/shared/logo_favi_color.webp`,
    description: "Lead Workz is a digital marketing and web design agency in Bangalore, combining consumer psychology, strategy and design to build brands that grow.",
    address: {
        "@type": "PostalAddress",
        streetAddress: "#60 Doddakallasandra Kanakapura Main Road, Near Doddakallasandra Metro Station",
        addressLocality: "Bengaluru",
        addressRegion: "Karnataka",
        postalCode: "560062",
        addressCountry: "IN",
    },
    telephone: "+91-9731267677",
    email: "info@leadworkz.com",
    hasMap: GBP_URL,
    sameAs: [
        GBP_URL,
        "https://www.instagram.com/lead_workz",
        "https://www.linkedin.com/company/https-www.leadworkz.com-/",
        "https://www.facebook.com/share/1CRWRhnrVm/",
        "https://www.youtube.com/@leadworkz",
    ],
};

export function getServiceSchema({ name, description, url }: { name: string; description: string; url: string }) {
    return {
        "@context": "https://schema.org",
        "@type": "Service",
        name,
        description,
        url,
        provider: { "@id": `${SITE_URL}/#organization` },
        areaServed: {
            "@type": "City",
            name: "Bengaluru",
        },
    };
}

export function getBreadcrumbSchema(items: { name: string; url: string }[]) {
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map((item, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: item.name,
            item: item.url,
        })),
    };
}

export const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    name: "Lead Workz",
    url: `${SITE_URL}/`,
    publisher: { "@id": `${SITE_URL}/#organization` },
};

export function getFaqSchema(faqs: { question: string; answer: string }[]) {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
            "@type": "Question",
            name: faq.question,
            acceptedAnswer: { "@type": "Answer", text: faq.answer },
        })),
    };
}

export function getArticleSchema({ title, description, url, image, datePublished, dateModified }: {
    title: string;
    description: string;
    url: string;
    image: string;
    datePublished?: string;
    dateModified?: string;
}) {
    return {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: title,
        description,
        url,
        mainEntityOfPage: url,
        image,
        ...(datePublished && { datePublished }),
        ...(dateModified && { dateModified }),
        author: { "@type": "Organization", "@id": `${SITE_URL}/#organization`, name: "Lead Workz", url: `${SITE_URL}/` },
        publisher: { "@id": `${SITE_URL}/#organization` },
    };
}
